import { ReferralShareLocation } from 'common/events/ClientEvents';
import React from 'react';
import EatingImage from 'src/assets/img/referral/eating.jpg';
import { ReactComponent as Curly } from 'src/assets/svg/curly.svg';
import { ReactComponent as SparklesOneSparkle } from 'src/assets/svg/sparkles_one_sparkle.svg';
import { ReactComponent as SparklesTwoSparkles } from 'src/assets/svg/sparkles_two_sparkles.svg';
import Button, { ButtonType } from 'web-common/src/shared/design-system/components/Button';
import { CloseButton } from 'web-common/src/shared/design-system/components/Button/CloseButton';
import { EllipsedEdgeColor, EllipsedEdgeContainer } from 'web-common/src/shared/design-system/EllipsedEdge';
import { ReferralShareButton } from './ReferralShareButton';

interface IProps {
  title: string;
  analyticsLocation: ReferralShareLocation;
  onClose: () => void;
  onLearnMore: () => void;
  minHeight?: number;
}

export const WSSReferralAdContent: React.FC<IProps> = ({
  title,
  analyticsLocation,
  onClose,
  onLearnMore,
  minHeight,
}) => (
  <div
    className='relative flex max-h-[85svh] w-full flex-col overflow-y-auto overscroll-contain bg-rice'
    style={minHeight ? { minHeight } : undefined}>
    <CloseButton className='absolute right-4 top-6 z-stepper' iconSize={24} onClick={onClose} />

    <div className='flex flex-1 flex-col items-center justify-center pt-6 text-center'>
      <h1 className='text-center text-h3 uppercase text-eggplant'>{title}</h1>
      <p className='mb-4 mt-3 w-60 text-body-400 text-eggplant-500'>
        Invite friends & family to the Weekly Shef Service
      </p>

      <section className='relative h-[220px] w-full'>
        <Curly className='absolute inset-x-0 -top-3 z-stepper mx-auto text-eggplant-500' />
        <img src={EatingImage} alt='' className='absolute inset-x-0 z-10 mx-auto w-[254px] rounded-md' />
      </section>
    </div>

    <EllipsedEdgeContainer className='pb-6 pt-20' color={EllipsedEdgeColor.EGGPLANT_500}>
      <div className='flex w-full items-center justify-center pb-3 pt-2 text-center'>
        <SparklesOneSparkle className='mr-2 size-4 text-eggplant-400' />
        <p className='text-center text-h6-bold uppercase text-milk'>Good food is better shared</p>
        <SparklesTwoSparkles className='size-8 text-eggplant-400' />
      </div>

      <div className='flex w-full justify-center px-4 pb-3'>
        <ReferralShareButton key={analyticsLocation} analyticsLocation={analyticsLocation} />
      </div>

      <div className='flex w-full justify-center'>
        <Button buttonType={ButtonType.TextLink} onClick={onLearnMore} darkBackground>
          Learn more
        </Button>
      </div>
    </EllipsedEdgeContainer>
  </div>
);
